// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import factionEntity from './entities/faction.json';
import factionMenu from '../pages/faction/menu.json';
import factionFullForm from '../pages/faction/forms/full.json';
import factionContextForm from '../pages/faction/forms/context.json';
import factionMiniForm from '../pages/faction/forms/mini.json';
import factionLookupForm from '../pages/faction/forms/lookup.json';
import factionTableView from '../pages/faction/views/table.json';
import factionStagesView from '../pages/faction/views/stages.json';
import factionCardsView from '../pages/faction/views/cards.json';
import factionInlineView from '../pages/faction/views/inline.json';
import factionBacklogView from '../pages/faction/views/backlog.json';
import factionSplitView from '../pages/faction/views/split.json';
import factionCalendarView from '../pages/faction/views/calendar.json';
import factionDashboardView from '../pages/faction/views/dashboard.json';

/** Тип запису «Фракція» зі сторінками пакета: меню, форми та подання з pages/faction/. */
export const factionDefinition: IRecordTypeDefinition = {
  ...factionEntity,
  views: assembleViewSet({
      table: factionTableView,
      stages: factionStagesView,
      cards: factionCardsView,
      inline: factionInlineView,
      backlog: factionBacklogView,
      split: factionSplitView,
      calendar: factionCalendarView,
      dashboard: factionDashboardView,
  }),
  form: factionFullForm,
  forms: { full: factionFullForm, context: factionContextForm, mini: factionMiniForm, lookup: factionLookupForm },
  menu: factionMenu,
} as IRecordTypeDefinition;
